import {
  MediaPlaybackRateMenu,
  MediaRenditionMenu,
  MediaCaptionsMenu,
  MediaAudioTrackMenu
} from 'media-chrome/react/menu'

export const playerSettingMenuItems = (browserLanguage) => {
  const settings = [
    {
      name: 'speed',
      title: browserLanguage.speed,
      description: '1x',
      submenu:
  <MediaPlaybackRateMenu rates='0.25 0.5 0.75 1 1.25 1.5 1.75 2' slot='submenu' hidden><div slot='title'>{browserLanguage.speed}</div></MediaPlaybackRateMenu>
    },
    {
      name: 'quality',
      title: browserLanguage.quality,
      description: 'automatica',
      submenu: <MediaRenditionMenu slot='submenu' hidden><div slot='title'>{browserLanguage.quality}</div></MediaRenditionMenu>
    },
    {
      name: 'captions',
      title: browserLanguage.captions,
      description: 'Off',
      submenu: <MediaCaptionsMenu slot='submenu' hidden><div slot='title'>{browserLanguage.captions}</div></MediaCaptionsMenu>
    },
    {
      name: 'audio',
      title: browserLanguage.audio,
      description: 'Off',
      submenu: <MediaAudioTrackMenu slot='submenu' hidden><div slot='title'>{browserLanguage.audio}</div></MediaAudioTrackMenu>
    }
  ]
  return settings
}
